import { __extends } from "tslib";
import React from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import DaEditorMonoView from '../Views/Mono';
// TODO lazy loading...
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Image.prototype.render = function () {
        var _a = this.props, data = _a.data, width = _a.width, config = _a.config, isHtml = _a.isHtml, settings = _a.settings;
        if (!data) {
            return React.createElement(LoadingIndicator, { view: "llama" });
        }
        return (React.createElement(DaEditorMonoView, { settings: settings, config: config, deviation: data, width: width, isHtml: isHtml }));
    };
    return Image;
}(React.Component));
export { Image };
//# sourceMappingURL=Image.js.map